<template>
  <b-dropdown
    :id="dropdownId"
    toggle-class="right-border-radius-unset right-border-none subject-input-dropdown"
    :disabled="disabled"
    ref="dropdown"
    class="subject-input-residency-list"
  >
    <template #button-content>
      <img
        v-if="selectedNationality"
        class="flag_img subject-input-flag"
        :src="selectedNationalityFlag"
        :alt="selectedNationality.iso2"
      />
      <span class="subject-input-arrow" v-if="!isView">
        {{ dropdownIsOpen ? '▲' : '▼' }}
      </span>
    </template>
    <template v-for="(item, key) in nationalities">
      <b-dropdown-item
        :key="key"
        :style="{cursor: 'pointer'}"
        @click="selectNationality(item.id)"
      >
        <img
          v-if="item.iso2"
          class="flag_img"
          :src="iconsPath + item.iso2 + '.svg'"
          alt=""
          width="20"
        />
        <span style="margin-left: 5px">
          <strong>{{ item.full_name }}</strong>
        </span>
      </b-dropdown-item>
    </template>
  </b-dropdown>
</template>

<script>
import applicationFormMixin from '@/common/mixins/applicationFormMixin'

export default {
  name: 'NationalityDropdown',

  mixins: [
    applicationFormMixin
  ],

  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    selectedId: {
      type: Number,
      default: 182
    },

    nationalities: {
      type: Array,
      default: () => [
        {
          id: 182,
          full_name: 'Россия',
          full_name_en: 'Russian Federation',
          iso_num: '643',
          iso2: 'RU',
          iso3: 'RUS',
          citizenship: 1,
          vessel_flag: 1
        },
        {
          id: 20,
          full_name: 'Беларусь',
          full_name_en: 'Belarus',
          iso_num: '112',
          iso2: 'BY',
          iso3: 'BLR',
          citizenship: 1,
          vessel_flag: 1
        },
        {
          id: 113,
          full_name: 'Казахстан',
          full_name_en: 'Kazakhstan',
          iso_num: '398',
          iso2: 'KZ',
          iso3: 'KAZ',
          citizenship: 1,
          vessel_flag: 1
        }
      ]
    },

    iconsPath: {
      type: String,
      default: process.env.BASE_URL + 'img/icons/countries/'
    }
  },

  emits: ['nationality-selected'],

  computed: {
    selectedNationality() {
      return this.nationalities.find(item => item.id === this.selectedId)
    },

    selectedNationalityFlag() {
      if (!this.selectedNationality || !this.selectedNationality.iso2) {
        return ''
      }
      return this.iconsPath + this.selectedNationality.iso2 + '.svg'
    },

    dropdownId() {
      return `dropdown-${Math.random().toString(36).substr(2, 9)}`
    },

    dropdownIsOpen() {
      return this.$refs.dropdown?.isShowing || false
    }
  },

  methods: {
    selectNationality(nationalityId) {
      this.$emit('nationality-selected', nationalityId)
    }
  }
}
</script>
